query instructorsCube($scenarioId: ID!, $filter: PaginationInput!, $originId: ID!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    instructors(filter: $filter) {
      items {
        id
        code
        name
        priority
        usable
        contract
        assignment {
          totalAssignedBlocks
        }
      }
      pageInfo {
        size
        page
        total
        hasNextPage
        hasPreviousPage
        __typename
      }
      __typename
    }
  }
}
